import React from 'react'

function PageNotFound() {
  return (
    <div>PageNotFound 404</div>
  )
}

export default PageNotFound